const configItem = {
    item: {
        listLayout: 'ItemListDefaultLayout',
        filterLayout: 'ItemFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getItem',
        listApiParamSet: {
            ip: 1,
            en: 1,
            page: 1,
            sp: 10,
            use: 1,
            obt: 'last_update',
            obs: 'desc',
        },
        pageRow: 10,
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        keyName: ''
    },
    userItem: {
        listLayout: 'ItemListUserLayout',
        filterLayout: 'ItemFilterUserLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getItem',
        listApiParamSet: {
            ip: 1,
            en: 1,
            page: 1,
            sp: 10,
            obt: 'last_update',
            obs: 'desc',
        },
        pageRow: 10,
        // sortOptions: {
        // 	keyName: 'obt',
        // 	orderName: 'obs',
        // },
        keyName: 'pr'

    },
    deleteList: {
        listLayout: 'ItemListDeleteLayout',
        filterLayout: 'ItemFilterDeleteLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getItem',
        listApiParamSet: {
            ip: 1,
            en: 1,
            page: 1,
            sp: 10,
            use: 0,
            obt: 'last_update',
            obs: 'desc',
        },
        pageRow: 10,
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        keyName: ''
    },
    detectionRequest: {
        listLayout: 'ItemListDetectionLayout',
        filterLayout: 'ItemFilterDetectionLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getDetection',
        listApiParamSet: {
            ip: 1,
            page: 1,
            sp: 10,
        },
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        pageRow: 10,
        keyName: ''
    },
    detectionRequestDetail: {
        writeLayouts: ['ItemWriteDetectionRequestLayout'],
        getFunc: 'getRequestDetail',
        detailApiParamSet: {},
        writeFunc: 'detailDetectionRequest',
        writeSuccessType: 1,
        keyName: 'l_idx',
    },
    detail: {
        writeLayouts: ['ItemWriteDefaultLayout'],
        getFunc: 'getItemDetail',
        detailApiParamSet: {},
        writeFunc: 'updateItem',
        writeApiParamSet: {
            im_enroll: 1,
        },
        parsingData: {
            memo: 'i_memo',
            isAdult: 'im_adult_chk',
            hashtag: 'hashtag',
        },
        fileInfo: [
            {
                fileName: 'detailThumbnail',
                fileType: 'item_detail',
            },
        ],
        writeSuccessType: 1,
        deleteFunc: 'deleteItem',
        deleteApiParamSet: {},
        deleteSuccessType: 1,
        deleteErrorTypes: {},
        keyName: 'id',
    },
    deleteItemDetail: {
        writeLayouts: ['ItemWriteDeleteItemLayout'],
        getFunc: 'getDetailDeleteItem',
        writeFunc: 'detailDeleteItem',
        writeSuccessType: 1,
    },
    autoItem: {
        writeLayouts: ['ItemWriteAutoLayout'],
        writeFunc: 'createItem',
        writeSuccessType: 1,
        parsingData: {
            category: 'ic_idx',
            collection: 'c_idx'
        },
        writeApiParamSet: {
            hashtag: [],
            imo_size: '',
            imo_city: "",
            imo_copyright: "",
            imo_country: "",
            imo_si: "",
            i_memo: "",
            i_status: 'nosale',
            i_type: 'digital',
            im_adult_chk: 0,
            im_enroll: 1,
            im_originator: 1,
            im_status: 9,
            im_type: 'photo',
        },
        writeValidatorArr: [
            'category',
            'selectMember',
            'files',
            'zipFiles',
            'collection',
        ],
        fileInfo: [
            {fileName: 'thumbnailFile', fileType: 'item',},
            {fileName: 'originalFile', fileType: 'original',},
        ]
    },
    collection: {
        listLayout: 'ItemListCollectionLayout',
        filterLayout: 'ItemFilterCollectionLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getCollect',
        listApiParamSet: {
            ip: 1,
        },
        pageRow: 10,
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        keyName: 'no'
    },
    memberCollection: {
        listLayout: 'ItemListMemberCollectionLayout',
        filterLayout: 'ItemFilterMemberCollectionLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getCollect',
        listApiParamSet: {
            ip: 1,
        },
        pageRow: 10,
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        keyName: 'no'
    },
    collectionDetailItemList: {
        listLayout: 'ItemListDefaultLayout',
        filterLayout: 'ItemFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getItem',
        listApiParamSet: {
            ip: 1,
            use: 1
        },
        pageRow: 10,
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        keyName: ''
    },
    collectionDetail: {
        writeLayouts: ['ItemWriteCollectionLayout'],
        getFunc: 'getCollect',
        detailApiParamSet: {
            opf: 1
        },
        writeFunc: 'updateCollect',
        writeApiParamSet: {},
        parsingData: {
            title: 'c_title',
            intro: "c_intro",
            owner: 'c_owner'
        },
        fileInfo: [
            {fileName: 'backImg', fileType: 'c_bg'},
            {fileName: 'mainImg', fileType: 'c_main'},
        ],
        writeSuccessType: 1,
        keyName: 'id',
    }
}
import util from "@/mixins/util";

export default {
    methods: {
        returnItemConfig(type) {
            return configItem[type];
        },

    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        al: {
            type: 'between',
            classname: 'filterDate'
        },
        out: {
            type: 'between',
            classname: 'filterOutDate'
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        bid: {
            type: 'query',
            classname: 'filterStatus',
        },
        bl: {
            type: 'match',
            classname: 'filterStatus',
        },
        cmty: {
            type: 'terms',
            classname: 'filterType',
        },
        //상태
        imst: {
            type: 'terms',
            classname: 'filterStatus'
        },
        ic: {
            type: 'terms',
            classname: 'filterCategory'
        },
        ty: {
            type: 'terms',
            classname: 'filterType'
        },
        ed: {
            type: 'terms',
            classname: 'filterEdition'
        },
        ina: {
            type: 'query',
            classname: 'searchInput',
        },
        orni: {
            type: 'query',
            classname: 'searchInput',
        },
        prni: {
            type: 'query',
            classname: 'searchInput',
        },
        prna: {
            type: 'query',
            classname: 'searchInput',
        },
        cuni: {
            type: 'query',
            classname: 'searchInput',
        },
        up: {
            type: 'between',
            classname: 'filterDate'
        },
        st: {
            type: 'terms',
            classname: 'filterStatus'
        },
        uid: {
            type: 'query',
            classname: 'searchInput',
        },
        mna: {
            type: 'query',
            classname: 'searchInput',
        },
        cti: {
            type: 'query',
            classname: 'searchInput',
        },
        ti: {
            type: 'query',
            classname: 'searchInput',
        },
        own: {
            type: 'match',
            classname: 'filterOwner',
        },
        pr: {
            type: 'between',
            classname: 'filterPrice',
            option: {
                start: 'prs',
                end: 'pre'
            }
        },
    }
}
